export const SET_KPI_LIST = 'SET_KPI_LIST'
export const SET_KPI_LIST_META = 'SET_KPI_LIST_META'
export const SET_KPI_LIST_BY_DATE = 'SET_KPI_LIST_BY_DATE'
export const SET_KPI_LIST_BY_HOUR = 'SET_KPI_LIST_BY_HOUR'
export const SET_KPI_LIST_FILTER_DATA = 'SET_KPI_LIST_FILTER_DATA'
export const SET_KPI_REPORTS_DATA = 'SET_KPI_REPORTS_DATA'
export const SET_KPI_STATISTICS = 'SET_KPI_STATISTICS'

export const KPI_INIT_STATE = {
    kpiList: [],
    kpiListMeta: {},
    kpiListByDate: [],
    kpiListByHour: [],
    kpiListFilterData: [],
    kpiReportsData: [],
    kpiStatistics: {
        leadsCount: 0,
        leadsCountIsManualFalse: 0,
        leadsCountIsManualTrue: 0,
        totalWebAndPhoneConverted: 0,
        totalWebConverted: 0,
        totalPhoneConverted: 0,
        leadSalesPerson: 0,
        percentSalesRep: 0,
        leadConvertedTodayIsManual: 0,
        leadConvertedTodayIsntManual: 0,
    },
};
